import SelectedCountriesHandler from '../../utils/selected-countries-handler';
import CountriesModule from '../../modules/countries-module';
import DocumentsCurriculaGfgModule from "../../modules/documents-curricula-gfg-module";
import TokenHandler from "../../utils/token-handler";

class Main {
	constructor() {
        //https://beige-unimaginable-idols.awork.io/tasks/5690015e-ffc1-ec11-997e-38563d6e6dce/details
        if (!TokenHandler.isKmk()) {
            window.location.replace(`${location.origin}/db/404-fehler`);
        }
        this.metaDescription = document.getElementById('meta-description');
        this.selCountries = new SelectedCountriesHandler();
		this.countriesModule = new CountriesModule(this.selCountries);
		this.documentsCurriculaGfgModule = new DocumentsCurriculaGfgModule(this.countriesModule);
	}

	run() {
        if (!!this.metaDescription) {
            document.title = 'Curricula - anabin: Infoportal zu ausländischen Bildungsabschlüssen';
        }
		this.countriesModule.getCountries().then(() => {
			this.initializeModules();

			this.selCountries.getAllSelectedCountries().forEach(countryObject => {
				if (countryObject) {
					// const countryArray = countryObject.split(':');
					// this.countriesModule.selectCountry(null, countryArray[0], countryArray[1]);
                    this.countriesModule.selectCountry(null, countryObject)
				}
			});
			this.countriesModule.renderCountryOption(this.countriesModule.countries);
			this.documentsCurriculaGfgModule.getData().then();
		});
	}


	initializeModules() {
		this.countriesModule.initialiseModules(this.documentsCurriculaGfgModule, [ this.documentsCurriculaGfgModule ]);
		this.documentsCurriculaGfgModule.initialise();
		this.documentsCurriculaGfgModule.dataTable.modalDom.addEventListener();
	}
}
const main = new Main();
main.run();


